import { deleteUser } from "../api/userService";

export const useDeleteUser = (setUsers) => {
    const remove = async (id) => {
        try {
        await deleteUser(id);
            setUsers((prev) => prev.filter((c) => c.id !== id));
        } catch (error) {
            console.error("Failed to delete user:", error);
            throw error;
        }
    };

    return { remove };
};